<script setup lang="ts">
interface Option {
  id: string | number
  value: string | boolean | number
  label: string
  itemClasses?: string
  labelClasses?: string
  errorMessage?: string
}

defineProps({
  label: {
    type: String,
    default: '',
  },
  labelClasses: {
    type: String,
    default: 'label-text font-semibold',
  },
  options: {
    type: Array as () => Option[],
    required: true,
    default: () => [],
  },
  required: {
    type: Boolean,
    default: false,
  },
  itemClasses: {
    type: String,
    default: '',
  },
  errorMessage: String, // Gérée par le parent
})

const modelValue = defineModel<string | boolean | number | null>()
</script>

<template>
  <label class="form-control w-full">
    <div class="label">
      <span :class="[labelClasses]">
        {{ label }}
        <span v-if="required" :class="[errorMessage ? 'text-red-500' : '']">*</span>
      </span>
    </div>
    <div class="flex space-x-4 my-1.5" :class="itemClasses">
      <label v-for="option in options" :key="option.id" class="flex items-center space-x-1">
        <input
          type="radio"
          :id="String(option.id)"
          :name="label.replace(/\s+/g, '-').toLowerCase()"
          :value="option.value"
          v-model="modelValue"
          :class="{ 'radio radio-xs': true, 'border-red-500': errorMessage }"
        />

        <span class="label-text">{{ option.label }}</span>
      </label>
    </div>
    <span v-if="errorMessage" class="text-red-500 text-sm">{{ errorMessage }}</span>
  </label>
</template>
